var _filter, _circle, _ellipse, _circle2, _circle3, _circle4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg13N(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "moon13n",
    cx: "40%",
    cy: "30%",
    r: "40%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#E2E8F0",
      stopOpacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#94A3B8",
      stopOpacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "snowClouds13n",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#CBD5E1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#94A3B8",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "snowShadow13n"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 3,
    stdDeviation: 2,
    floodColor: "#475569",
    floodOpacity: 0.4
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 6,
    fill: "url(#moon13n)",
    opacity: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 57,
    cy: 38,
    rx: 20,
    ry: 13,
    fill: "url(#snowClouds13n)",
    filter: "url(#snowShadow13n)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 33,
    r: 10,
    fill: "url(#snowClouds13n)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 33,
    r: 12,
    fill: "url(#snowClouds13n)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 28,
    r: 8,
    fill: "url(#snowClouds13n)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    stroke: "#E2E8F0",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(47,58)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -4,
    y1: 0,
    x2: 4,
    y2: 0,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -4,
    x2: 0,
    y2: 4,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: -3,
    x2: 3,
    y2: 3,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: 3,
    x2: 3,
    y2: -3,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62,65)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: 0,
    x2: 3,
    y2: 0,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -3,
    x2: 0,
    y2: 3,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2,
    y1: -2,
    x2: 2,
    y2: 2,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2,
    y1: 2,
    x2: 2,
    y2: -2,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,68)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: 0,
    x2: 3,
    y2: 0,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -3,
    x2: 0,
    y2: 3,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2,
    y1: -2,
    x2: 2,
    y2: 2,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2,
    y1: 2,
    x2: 2,
    y2: -2,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54,72)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -4,
    y1: 0,
    x2: 4,
    y2: 0,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -4,
    x2: 0,
    y2: 4,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: -3,
    x2: 3,
    y2: 3,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: 3,
    x2: 3,
    y2: -3,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg13N);
export default __webpack_public_path__ + "static/media/13n.0c3d463a1159cb498aa755e0369c0452.svg";
export { ForwardRef as ReactComponent };